import React from "react";
import { Container } from "react-bootstrap";
import "./GSTRegistration.css";

const GSTRegistration = () => {
  return (
    <section className="gst-page">
      <Container>
        <h1 className="gst-title">GST Registration & Compliance</h1>

        <p>
          GST-Compliant Travel & MICE Company in India
        </p>

        <p>
          Plenary Holidays is a fully GST-registered travel and MICE management company based in New Delhi, India.
        </p>

        <p>
          With over 16 years of industry experience, we provide GST-compliant invoicing and structured financial documentation for domestic holidays, international tours, corporate travel programs, and MICE events.
        </p>

        <p>
          Whether you are a leisure traveler requiring proper tax invoices or a corporate client seeking compliant billing for conferences, incentive tours, and group travel, Plenary Holidays ensures complete transparency and adherence to Indian tax regulations.
        </p>

<h3>Our GST Registration Details</h3>

<table className="gst-table">
  <tbody>
    <tr>
      <td>Company Name</td>
      <td>Plenary Holidays</td>
    </tr>

    <tr>
      <td>GST Registration Number (GSTIN)</td>
      <td>07AQRPG0017C1ZC</td>
    </tr>

    <tr>
      <td>ARN Number</td>
      <td>AA070617011156F</td>
    </tr>

    <tr>
      <td>PAN Number</td>
      <td>AQRPG0017C</td>
    </tr>

    <tr>
      <td>Former Service Tax Registration Number</td>
      <td>AQRPG0017CSD001</td>
    </tr>

    <tr>
      <td>Registered Office Address</td>
      <td>
        311, H-4, Vardhman North Ex Plaza <br />
        Netaji Subhash Place, Pitampura <br />
        New Delhi – 110034, India
      </td>
    </tr>

    <tr>
      <td>Authorized Contact Person</td>
      <td>Mrs. Sonali Bansal</td>
    </tr>

    <tr>
      <td>Contact Number</td>
      <td>+91-9555432221</td>
    </tr>

    <tr>
      <td>Email</td>
      <td>mail@plenaryholidays.com</td>
    </tr>
  </tbody>
</table>

        <p><strong>Why GST Compliance Matters in Travel & MICE</strong></p>

        <p>
          For corporate and institutional clients, GST compliance is critical for:
        </p>

        <p>
          • Input Tax Credit (ITC) eligibility <br />
          • Proper accounting and audit documentation <br />
          • Corporate reimbursement processes <br />
          • Government and PSU bookings <br />
          • MICE & event billing transparency
        </p>

        <p>
          As a GST-registered travel company in Delhi, Plenary Holidays issues:
        </p>

        <p>
          • GST-compliant invoices <br />
          • Detailed tax breakdowns <br />
          • Official payment receipts <br />
          • Structured milestone billing for corporate events
        </p>

        <p><strong>GST-Compliant Services We Provide</strong></p>

        <p><strong>Leisure Travel</strong></p>

        <p>
          • Domestic holiday packages <br />
          • International tour packages <br />
          • Group departures <br />
          • Air ticketing and hotel bookings
        </p>

        <p><strong>MICE & Corporate Travel</strong></p>

        <p>
          • Conferences & exhibitions <br />
          • Incentive travel programs <br />
          • Corporate offsites <br />
          • Group logistics & event management
        </p>

        <p>
          All billing is aligned with prevailing GST rules and applicable tax slabs.
        </p>

        <p><strong>Accounts & Payment Compliance</strong></p>

        <p>
          We accept secure and documented payment methods including:
        </p>

        <p>
          • NEFT <br />
          • RTGS <br />
          • IMPS <br />
          • UPI <br />
          • Remittance
        </p>

        <p>
          All transactions are supported by official GST-compliant invoicing and accounting documentation.
        </p>

        <p><strong>Need GST-Compliant Travel Support?</strong></p>

        <p>
          If your organization requires a GST-compliant travel agency in Delhi for leisure tours, corporate travel, or MICE event management, our accounts and corporate team will assist you with complete documentation.
        </p>

        <p>
          📧 mail@plenaryholidays.com <br />
          📞 +91-9555432221
        </p>

        <p><strong>Our Commitment to Transparency</strong></p>

        <p>
          Plenary Holidays operates with structured financial governance and transparent billing practices.
        </p>

        <p>
          We understand the importance of compliance, especially for corporate travel procurement and large-scale event management, and remain committed to maintaining clear and accountable financial processes.
        </p>

      </Container>
    </section>
  );
};

export default GSTRegistration;